/* src/app/components/car-button/car-button.component.scss */
.car-button {
  height: 50.4px;
  width: 100%;
  font-size: 16px;
  --padding-start: 16px;
  --padding-end: 16px;
}
.car-button__content {
  width: 100%;
  align-items: center;
  padding-inline-end: 4px;
}
.car-button__text {
  flex: 1 1 auto;
  min-width: 0;
  text-align: start;
}
.car-button__text h6,
.car-button__text p {
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.car-button ion-icon {
  flex: 0 0 auto;
  min-height: 28px;
  min-width: 28px;
}
/*# sourceMappingURL=car-button.component.css.map */
